import { render, staticRenderFns } from "./AppErrorStatus.vue?vue&type=template&id=48bcdac6&scoped=true&"
import script from "./AppErrorStatus.vue?vue&type=script&lang=js&"
export * from "./AppErrorStatus.vue?vue&type=script&lang=js&"
import style0 from "./AppErrorStatus.vue?vue&type=style&index=0&id=48bcdac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bcdac6",
  null
  
)

export default component.exports